import {Component, computed, inject, model, OnDestroy, signal} from '@angular/core';
import {NzMessageService} from 'ng-zorro-antd/message';
import {orderBy} from 'lodash-es';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {NzEmptyComponent} from 'ng-zorro-antd/empty';
import {Halls} from './laundry-status.component';
import {FormsModule} from '@angular/forms';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzDividerComponent} from 'ng-zorro-antd/divider';
import {NzInputDirective} from 'ng-zorro-antd/input';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import {LavatoryResultComponent} from './lavatory-result.component';

export const Floors = [
  {'hall': 'P', 'floor': 0, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 8, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 12, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 3, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 4, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 15, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 9, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 12, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 7, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 2, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 14, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 8, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 6, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 11, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 16, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 5, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 9, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 12, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 17, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 3, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 2, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 6, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 8, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 16, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 1, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 8, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 11, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 4, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 6, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 9, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 9, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 3, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 5, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 5, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 15, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 6, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 12, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 4, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 5, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 11, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 1, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 7, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 3, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 14, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 2, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 15, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 11, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 7, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 7, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 15, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 14, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 14, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 4, 'gender': 'M'}];

@Component({
  selector: 'app-lavatory-occupancy',
  imports: [
    NzRowDirective,
    NzColDirective,
    NzEmptyComponent,
    FormsModule,
    NzButtonComponent,
    NzIconModule,
    NzDividerComponent,
    NzInputDirective,
    LavatoryResultComponent,
  ],
  template: `
    <div class="container">
      <nz-row [nzGutter]="[8,8]">
        <nz-col nzSpan="20">
          <input [(ngModel)]="apiUrl" nz-input/>
        </nz-col>
        <nz-col nzSpan="4">
          <button (click)="reload()" nz-button nzBlock>
            <span nz-icon nzType="reload"></span> Reload
          </button>
        </nz-col>
      </nz-row>
      <div style="margin-top: 15px;">
        <nz-row [nzGutter]="[8,8]">
          @for (h of availableHalls; track h.id) {
            <nz-col nzSpan="6">
              <button (click)="selectHall(h)" [nzType]="hall()?.id === h.id ? 'primary' : 'default'" nz-button style="width: 100%;">
                {{ h.abbr }}
              </button>
            </nz-col>
          }
        </nz-row>
      </div>
      @if (availableFloors().length > 0) {
        <div style="margin-top: 15px;">
          <nz-row [nzGutter]="[8,8]">
            @for (f of availableFloors(); track f.floor) {
              <nz-col nzSpan="4">
                <button (click)="selectFloor(f.floor)" [class.selected-floor]="floor() === f.floor" [class.floor-male]="f.gender === 'M'"
                        [class.floor-female]="f.gender === 'F'" nz-button style="width: 100%;">
                  {{ f.floor }}F
                </button>
              </nz-col>
            }
          </nz-row>
        </div>
      }
      <nz-divider></nz-divider>
      @let s = scores$();
      @if (s) {
        <nz-row [nzGutter]="[8,8]">
          <nz-col nzSpan="12">
            <app-lavatory-result [sensors]="s.washroom" [inspectedCache]="inspectedCache()"
                                 (onInspect)="handleInspect($event.sensorId, $event.success)"/>
          </nz-col>
          <nz-col nzSpan="12">
            <app-lavatory-result [sensors]="s.bathroom" [inspectedCache]="inspectedCache()"
                                 (onInspect)="handleInspect($event.sensorId, $event.success)"/>
          </nz-col>
        </nz-row>
      } @else {
        <nz-empty></nz-empty>
      }
    </div>
  `,
  styles: `
    .container {
      padding: 15px;
    }

    .selected-floor {
      border-color: #1890ff !important;
      box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
    }

    .floor-male {
      background-color: #9bc9fa;
    }

    .floor-female {
      background-color: #f1bebe;
    }
  `
})
export class LavatoryOccupancyComponent implements OnDestroy {
  apiUrl = localStorage.getItem('lavatory-status-api-url') ?? '';
  private sseSource: EventSource = null;
  public scores$ = signal(null);
  private message = inject(NzMessageService);
  private http = inject(HttpClient);
  inspectedCache = signal<Set<string>>(new Set());
  availableHalls: any[] = [];
  hall = model(null);
  floor = model(1);

  availableFloors = computed(() => {
    const selectedHall = this.hall();
    if (!selectedHall) {
      return [];
    }
    return Floors.filter(f => f.hall === selectedHall.id).sort((a, b) => a.floor - b.floor);
  });

  constructor() {
    this.availableHalls = [
      ...Halls.filter(h => h.compound === 'MOS' && h.code !== '12'),
      {
        id: 'P',
        code: 'P',
        abbr: 'SP',
        name: 'Sports Hall',
        compound: 'MOS'
      }
    ];
  }

  selectHall(hall: any): void {
    this.hall.set(hall);
    this.floor.set(null);
    this.scores$.set(null);
  }

  async selectFloor(floor: number): Promise<void> {
    this.floor.set(floor);
    this.scores$.set(null);
    await this.reload();
  }

  async handleInspect(sensorId: string, success: boolean): Promise<void> {
    try {
      await firstValueFrom(this.http.post('https://iot.cityu-sro.hk/api-mos/inspect', {
        sensor_id: sensorId,
        result: {'success': success, 'inspect_token': 'ULir*f4Y_6I{RadO'},
        timestamp: new Date()
      }));
      this.inspectedCache.update(current => new Set(current).add(sensorId));
    } catch (error) {
      this.message.error(`Failed to record inspection for ${sensorId}`);
    }
  }

  ngOnDestroy(): void {
    if (this.sseSource !== null) {
      this.sseSource.close();
    }
  }

  async reload() {
    if (this.sseSource !== null) {
      this.sseSource.close();
    }
    const hall = this.hall();
    const floor = this.floor();
    if (!!this.apiUrl && !!hall && floor !== null) {
      localStorage.setItem('lavatory-status-api-url', this.apiUrl);
      const prefix = hall.code === 'P' ? '' : 'H';
      this.sseSource = new EventSource(`${this.apiUrl}/${prefix}${hall.code}_${floor}`);
      this.sseSource.onmessage = (e: MessageEvent) => {
        const list = orderBy(JSON.parse(e.data) as any[], 'sensor_id');
        this.scores$.set({
          'bathroom': list.filter(d => d.sensor_id.indexOf('-B') > 1),
          'washroom': list.filter(d => d.sensor_id.indexOf('-T') > 1),
        });
      };
      this.sseSource.onerror = (err) => {
        this.message.error('SSE Error');
      };
    }
  }
}
